module.exports = __webpack_public_path__ + "static/media/gardenSideLights.cd7848d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gardenSideLights.jpg
// module id = 171
// module chunks = 0